import Alpine from 'alpinejs';
import {intersect} from "@alpinejs/intersect";
import Glide from "@glidejs/glide";
import './components';

console.debug("--- USING " + process.env.NODE_ENV.toUpperCase() + " BUILD ---");

// -- VARIABLES -- //
const CAPTCHA_CONTAINER_ID = 'contact-form__captcha-container';
const captchaReady = Promise.withResolvers();
const formValidity = Alpine.reactive({
    fullName: {
        valid: false
    },
    email: {
        valid: false
    },
    message: {
        valid: false
    },
    captcha: {
        valid: false
    },
});
// -- //

// -- GLOBAL METHODS (necessary for captcha) -- //
window.captchaCallback = () => {
    console.debug('Captcha loaded!');
    captchaReady.resolve(window.grecaptcha);
};

// Zabezpieczenie na wypadek, gdyby skrypt reCAPTCHA wykonal sie przed tym modulem
// (wtedy captchaCallback jeszcze nie istnial i onload przepadl).
if (window.grecaptcha?.render) {
    captchaReady.resolve(window.grecaptcha);
}
// -- //

// -- ALPINE -- //
Alpine.plugin(intersect);

/**
 * expression - { autoplay: number | boolean, small: boolean }
 */
Alpine.directive('glide', (el, {expression}, {evaluate}) => {
    const options = evaluate(expression);
    const isSmall = options?.small;
    const autoplay = options?.autoplay ?? 4000;

    new Glide(el, {
        type: 'carousel',
        perView: isSmall ? 1 : 3,
        autoplay: autoplay,
        ...(!isSmall && {
            breakpoints: {
                1400: {
                    perView: 2
                },
                1024: {
                    perView: 1
                }
            }
        })
    }).mount();
});

Alpine.data('formHandler', () => ({
    fullName: undefined,
    email: undefined,
    message: undefined,
    renderCaptcha: async () => {
        console.debug('Starting captcha render');
        const captcha = await captchaReady.promise;

        captcha.render(CAPTCHA_CONTAINER_ID, {
            sitekey: process.env.CAPTCHA_SITE_KEY,
            callback: () => {
                formValidity.captcha = null;
            },
            'expired-callback': () => {
                formValidity.captcha = {
                    valid: false,
                    expired: true
                };
            },
            'error-callback': () => {
                formValidity.captcha = {
                    valid: false,
                };
            },
        });
        console.debug('Captcha rendered!');
    },
    onSubmit: async (event) => {
        const store = Alpine.store('formData');
        const captcha = await captchaReady.promise;

        store.captcha = captcha.getResponse();
        store.loading = true;

        const bodyJson = JSON.stringify({
            fullName: store.fullName,
            email: store.email,
            message: store.message,
            captcha: store.captcha
        });

        try {
            const response = await fetch(process.env.API_URL + '/contact', {
                method: 'POST',
                body: bodyJson,
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }

            event.target.reset();
            store.serverSuccess = true;
        } catch (error) {
            console.error(error.message);
            store.submitted = true;
            store.serverSuccess = false;
        }

        window.grecaptcha.reset();
        store.submitted = true;
        store.loading = false;
    },
    setValidity: (name, validity) => {
        if (validity?.valid) {
            formValidity[name] = null;
            return;
        }

        formValidity[name] = validity;
    }
}));

// todo: server statuses could be moved elsewhere
Alpine.store('formData', {
    fullName: undefined,
    email: undefined,
    message: undefined,
    captcha: undefined,

    submitted: false,
    valid: false,
    touched: false,
    serverSuccess: false,
    loading: false
});

Alpine.effect(() => {
    const formDataStore = Alpine.store('formData');
    formDataStore.valid = Object.values(formValidity).every(value => value === null);
    formDataStore.touched = true;
    formDataStore.submitted = false;
});

// Link "Zapytaj o wycene" z /realizacje przychodzi jako /kontakt?projekt=<nazwa>.
// Wstepnie wypelniamy wiadomosc i oznaczamy to pole jako poprawne, inaczej przycisk
// wysylki zostalby zablokowany mimo wypelnionej tresci.
const requestedProject = new URLSearchParams(window.location.search).get('projekt');
if (requestedProject) {
    const projectName = requestedProject.replace(/\s+/g, ' ').trim().slice(0, 60);

    if (projectName) {
        Alpine.store('formData').message =
            `Dzień dobry, proszę o wycenę projektu ${projectName}.`;
        formValidity.message = null;
    }
}

window.Alpine = Alpine;
Alpine.start();
// -- //
